import { render, staticRenderFns } from "./EmployeeLayout.vue?vue&type=template&id=450aba30&scoped=true"
import script from "./EmployeeLayout.vue?vue&type=script&lang=js"
export * from "./EmployeeLayout.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLayout.vue?vue&type=style&index=0&id=450aba30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450aba30",
  null
  
)

export default component.exports